import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import EventListener from 'react-event-listener';
import getDisplayName from 'components/helpers/getDisplayName';

export default function withLoadByScroll(WrappedComponent) {
    return class extends Component {

        static displayName = `withLoadByScroll(${getDisplayName(WrappedComponent)})`;

        prevPageYOffset = 0;

        render() {
            return (
                <div>
                    <WrappedComponent ref='container'
                                      {...this.props}/>
                    <EventListener target='window'
                                   onScroll={this.handleScroll}/>
                </div>
            );
        }

        handleScroll = () => {
            if (this.needLoadByScroll())
                this.refs.container.onScrollMore();

            this.prevPageYOffset = window.pageYOffset;
        };

        needLoadByScroll() {
            const isScrollingDown = window.pageYOffset > this.prevPageYOffset;

            return isScrollingDown && this.isContainerBottomAlmostVisible();
        }

        isContainerBottomAlmostVisible() {
            const windowBottom = window.innerHeight;

            const container = ReactDOM.findDOMNode(this.refs.container);
            const containerBottom = container.getBoundingClientRect().bottom;

            const gap = 70;

            return containerBottom - gap < windowBottom;
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/hoc/withLoadByScroll.js